module.exports = __webpack_public_path__ + "static/media/spinner_teal.faf21e11.svg";